<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <b-form class="form-compra">
          <b-card>
            <div slot="header">Negociación de Facturas de Crédito Electrónicas</div>
            <b-form-group label="Agente" label-for="proveedor" :label-cols="labelCols" horizontal>
              <b-input-group>
                <b-input-group-append class="filter-search-icons" @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input id="proveedor" :value="proveedorNombre" :state="proveedorValido" readonly type="text" />
                <b-form-invalid-feedback id="proveedorFeedback">
                  {{ proveedorInvalidoMsj }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Nro.Boleto" label-for="numeroBoleto" :label-cols="labelCols">
              <b-form-input
                id="numeroBoleto"
                v-model.trim="$v.numeroBoleto.$model"
                :state="numeroBoletoValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroBoletoFeedback">
                {{ numeroBoletoInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <app-banco-cuenta
              label="Cuenta"
              :nombre="bancoCuentaNombre"
              :lista="bancosCuentasList"
              :labelCols="labelCols"
              :valido="bancoCuentaValida"
              :msjInvalido="bancoCuentaInvalidaMsj"
              @updated="bancoCuentaActualizada">
            </app-banco-cuenta>

            <b-form-group label="Fecha Acredit." label-for="fechaAcreditacion" :label-cols="labelCols" horizontal>
              <b-form-input id="fechaAcreditacion" v-model="fechaAcreditacion" type="date"> </b-form-input>
            </b-form-group>

            <b-form-group label="Importe Acreditar" label-for="montoAcreditado" :label-cols="labelCols">
              <b-form-input
                id="montoAcreditado"
                v-model.trim="$v.montoAcreditado.$model"
                :state="montoAcreditadoValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="montoAcreditadoFeedback">
                {{ montoAcreditadoInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Intereses" label-for="montoIntereses" :label-cols="labelCols">
              <b-form-input
                id="montoIntereses"
                v-model.trim="$v.montoIntereses.$model"
                :state="montoInteresesValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="montoInteresesFeedback">
                {{ montoInteresesInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Gastos" label-for="montoGastos" :label-cols="labelCols">
              <b-form-input
                id="montoGastos"
                v-model.trim="$v.montoGastos.$model"
                :state="montoGastosValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="montoGastosFeedback">
                {{ montoGastosInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Iva" label-for="montoIvaInscripto" :label-cols="labelCols">
              <b-form-input
                id="montoIvaInscripto"
                v-model.trim="$v.montoIvaInscripto.$model"
                :state="montoIvaInscriptoValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="montoIvaInscriptoFeedback">
                {{ montoIvaInscriptoInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Percep.Iva" label-for="montoPercepcionIva" :label-cols="labelCols">
              <b-form-input
                id="montoPercepcionIva"
                v-model.trim="$v.montoPercepcionIva.$model"
                :state="montoPercepcionIvaValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="montoPercepcionIvaFeedback">
                {{ montoPercepcionIvaInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Percep.Ganancias" label-for="montoPercepcionGanancias" :label-cols="labelCols">
              <b-form-input
                id="montoPercepcionGanancias"
                v-model.trim="$v.montoPercepcionGanancias.$model"
                :state="montoPercepcionGananciasValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="montoPercepcionGananciasFeedback">
                {{ montoPercepcionGananciasInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Percep.IIBB"
              label-for="montoPercepcionesProvinciales"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append
                    class="filter-search-icons" 
                    @click="setPercepcionesProvinciales">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="montoPercepcionesProvinciales"
                  :value="montoPercepcionesProvinciales | numero(2, true)"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Percep.C.I." label-for="montoPercepcionComercioIndustria" :label-cols="labelCols">
              <b-form-input
                id="montoPercepcionComercioIndustria"
                v-model.trim="$v.montoPercepcionComercioIndustria.$model"
                :state="montoPercepcionComercioIndustriaValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="montoPercepcionComercioIndustriaFeedback">
                {{ montoPercepcionComercioIndustriaInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Otros Impuestos:"
              label-for="montoOtrosImpuestos"
              :label-cols="labelCols"
              description="Otros Impuestos o Percepciones"
              horizontal>
              <b-form-input 
                id="montoOtrosImpuestos"
                v-model.trim= "$v.montoOtrosImpuestos.$model" 
                :state="montoOtrosImpuestosValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="montoOtrosImpuestosFeedback">
                {{ montoOtrosImpuestosInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
           
            <b-form-group 
                label="Retenciones" 
                label-for="retencionesClientes" 
                :label-cols="labelCols" 
                horizontal>
              <b-input-group>
                <b-input-group-append class="filter-search-icons" @click="agregarRetencionCliente">
                  <b-input-group-text>
                    <i class="fa fa-plus"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="retencionesClientes" 
                  :value="montoRetencionesClientes | numero(2, true)" 
                  readonly>
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-table
              v-if="retencionesClientes.length != 0"
              hover
              responsive="sm"
              class="cobros-documentos"
              :busy="tableBusy"
              :items="retencionesClientes"
              :fields="retencionesClientesFields">
              <template v-slot:cell(fechaComprobante)="data">
                {{ data.item.fechaComprobante | fecha }}
              </template>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda }}
              </template>
              <template v-slot:cell(borrar)="data">
                <i class="fa fa-remove" @click.stop="borrarRetencionCliente(data.item)"></i>
              </template>
            </b-table>

            <b-form-group
              label="Total"
              label-for="total"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="total"
                :value="montoTotal"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card>

          <b-card>
            <b-form-group label="Observaciones" label-for="observaciones" :label-cols="2" horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model"
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <app-a-b-m-button @save="save" @cancel="goList" />

    <b-modal
      ref="searchProveedorModal"
      title="Seleccionar Proveedor"
      header-bg-variant="light"
      hide-footer
      lazy
      modal-class="proveedores-search-modal">
      <app-search-proveedor @proveedorSeleccionado="proveedorSeleccionado"> </app-search-proveedor>
    </b-modal>

    <b-modal
      ref="addRetencionClienteModal"
      title="Retenciones de Clientes"
      header-bg-variant="light"
      hide-footer
      lazy
      modal-class="modalABM">
      <app-retencion-cliente @retencionClienteAgregada="retencionClienteAgregada" @cancel="retencionClienteCancelada">
      </app-retencion-cliente>
    </b-modal>

    <b-modal ref="percepcionesModal" 
        title="Percepciones de IIBB"
        header-bg-variant= "light" 
        hide-footer
        hide-header-close
        modal-class="modalABM percepcionesModal"
        lazy>
      <app-percepciones
        :percepciones="percepcionesProvinciales" 
        @updatePercepcionesProvinciales="updatePercepcionesProvinciales"
        @closePercepcionesProvinciales="closePercepcionesProvinciales">
      </app-percepciones>  
    </b-modal>

    <app-mensaje :modalMsj="modalMsj" :modalMensaje="modalMensaje" @okAction="okAction" @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue'
import RetencionCliente from '../retencionesclientes/ABM.vue'
import Percepciones from '../compras/Percepciones.vue'
import ABMButtons from '../shared/abmButtons.vue'
import BancoCuenta from '../shared/abmSelect.vue'
import Mensaje from '../shared/msjModal.vue'
import { msjModal } from '../../mixins/modalDialogs'
import { decimal, required, numeric, minValue, maxLength } from 'vuelidate/lib/validators'
import helpers from '../../mixins/helpers'

import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'ventaNegociacion/getField',
  mutationType: 'ventaNegociacion/updateField',
})

export default {
  name: 'VentaNegociacion',
  components: {
    appSearchProveedor: SearchProveedor,
    appPercepciones: Percepciones,
    appABMButton: ABMButtons,
    appBancoCuenta: BancoCuenta,
    appRetencionCliente: RetencionCliente,
    appMensaje: Mensaje,
  },
  mixins: [msjModal],
  data() {
    return {
      noValidar: true,
      proveedorValido: null,
      proveedorInvalidoMsj: '',
      bancoCuentaValida: null,
      bancoCuentaInvalidaMsj: '',
      numeroBoletoValido: null,
      numeroBoletoInvalidoMsj: '',
      montoAcreditadoValido: null,
      montoAcreditadoInvalidoMsj: '',
      montoInteresesValido: null,
      montoInteresesInvalidoMsj: '',
      montoGastosValido: null,
      montoGastosInvalidoMsj: '',
      montoIvaInscriptoValido: null,
      montoIvaInscriptoInvalidoMsj: '',
      montoPercepcionIvaValido: null,
      montoPercepcionIvaInvalidoMsj: '',
      montoPercepcionGananciasValido: null,
      montoPercepcionGananciasInvalidoMsj: '',
      montoPercepcionComercioIndustriaValido: null,
      montoPercepcionComercioIndustriaInvalidoMsj: '',
      montoOtrosImpuestosValido: null,
      montoOtrosImpuestosInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      bancosCuentas: [],
      bancosCuentasList: [],

      tableBusy: false,
      labelCols: 2,
      inicializando: false,

      retencionesClientesFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha',
        },
        {
          key: 'retencionTipoNombre',
          label: 'Tipo',
        },
        {
          key: 'retencionRegimenNombre',
          label: 'Regimen',
        },
        { key: 'importe' },
        {
          key: 'borrar',
          label: '',
          class: 'table-remove-icon',
        },
      ],
    }
  },
  computed: {
    ...mapFields([
      'proveedor',
      'proveedorNombre',
      'bancoCuenta',
      'bancoCuentaNombre',
      'numeroBoleto',
      'fechaAcreditacion',
      'montoAcreditado',
      'montoIntereses',
      'montoGastos',
      'montoIvaInscripto',
      'montoIvaNoInscripto',
      'montoPercepcionIva',
      'montoPercepcionGanancias',
      'montoPercepcionComercioIndustria',
      'percepcionesProvinciales',
      'montoPercepcionesProvinciales',
      'montoOtrosImpuestos',
      'observaciones',
      'montoRetencionesClientes',
      'retencionesClientes',
    ]),
    montoTotal() {
      const total = parseFloat(this.montoAcreditado || 0)
        + parseFloat(this.montoIntereses || 0)
        + parseFloat(this.montoGastos || 0)
        + parseFloat(this.montoIvaInscripto || 0)
        + parseFloat(this.montoIvaNoInscripto || 0)
        + parseFloat(this.montoPercepcionIva || 0)
        + parseFloat(this.montoPercepcionGanancias || 0)
        + parseFloat(this.montoPercepcionComercioIndustria || 0)
        + parseFloat(this.montoOtrosImpuestos || 0)
        + parseFloat(this.montoRetencionesClientes || 0)

      return helpers.methods.roundToTwo(total)
    },
  },
  created() {
    const ventaId = this.$route.params.id

    this.inicializando = true
    this.$store.dispatch('ventaNegociacion/inicializar', ventaId).then(() => {
      this.getDatosAdicionales()
    })
  },
  methods: {
    getDatosAdicionales() {
      let vm = this

      this.$store
        .dispatch('bancoscuentas/getList')
        .then(() => {
          vm.bancosCuentas = this.$store.getters['bancoscuentas/list']
          vm.bancosCuentasList = this.$store.getters['bancoscuentas/selectList']
          vm.inicializando = false
        })
        .catch(() => this.showAlert('Se produjo un error al recuperar la lista de cuentas bancarias.', 'danger'))
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch()
            this.displayErrores(event.target.id)
          }
        }
      }
    },
    displayErrores(field) {
      var validarTodos = false
      var campo = ''

      if (field) {
        campo = field
      } else {
        validarTodos = true
      }

      if (campo == 'numeroBoleto' || validarTodos) {
        if (this.$v.numeroBoleto.$error) {
          this.numeroBoletoValido = false
          if (!this.$v.numeroBoleto.required) {
            this.numeroBoletoInvalidoMsj = 'Debe ingresar el número de boleto'
          } else if (!this.$v.observaciones.numeric || !this.$v.observaciones.minValue) {
            this.numeroBoletoInvalidoMsj = 'El monto ingresado debe ser un valor numérico'
          }
        } else {
          this.numeroBoletoValido = null
          this.numeroBoletoInvalidoMsj = ''
        }
      }

      if (campo == 'montoAcreditado' || validarTodos) {
        this.montoAcreditadoValido = null
        this.montoAcreditadoInvalidoMsj = this.displayErrorMonto(
          this.$v.montoAcreditado.$error,
          this.$v.montoAcreditado.decimal,
          this.$v.montoAcreditado.minValue
        )

        if (this.montoAcreditadoInvalidoMsj.trim() != '') {
          this.montoAcreditadoValido = false
        }
      }

      if (campo == 'montoIntereses' || validarTodos) {
        this.montoInteresesValido = null
        this.montoInteresesInvalidoMsj = this.displayErrorMonto(
          this.$v.montoIntereses.$error,
          this.$v.montoIntereses.decimal,
          this.$v.montoIntereses.minValue
        )

        if (this.montoInteresesInvalidoMsj.trim() != '') {
          this.montoInteresesValido = false
        }
      }

      if (campo == 'montoGastos' || validarTodos) {
        this.montoGastosValido = null
        this.montoGastosInvalidoMsj = this.displayErrorMonto(
          this.$v.montoGastos.$error,
          this.$v.montoGastos.decimal,
          this.$v.montoGastos.minValue
        )

        if (this.montoGastosInvalidoMsj.trim() != '') {
          this.montoGastosValido = false
        }
      }

      if (campo == 'montoIvaInscripto' || validarTodos) {
        this.montoIvaInscriptoValido = null
        this.montoIvaInscriptoInvalidoMsj = this.displayErrorMonto(
          this.$v.montoIvaInscripto.$error,
          this.$v.montoIvaInscripto.decimal,
          this.$v.montoIvaInscripto.minValue
        )

        if (this.montoIvaInscriptoInvalidoMsj.trim() != '') {
          this.montoIvaInscriptoValido = false
        }
      }

      if (campo == 'montoPercepcionIva' || validarTodos) {
        this.montoPercepcionIvaValido = null
        this.montoPercepcionIvaInvalidoMsj = this.displayErrorMonto(
          this.$v.montoPercepcionIva.$error,
          this.$v.montoPercepcionIva.decimal,
          this.$v.montoPercepcionIva.minValue
        )

        if (this.montoPercepcionIvaInvalidoMsj.trim() != '') {
          this.montoPercepcionIvaValido = false
        }
      }

      if (campo == 'montoPercepcionGanancias' || validarTodos) {
        this.montoPercepcionGananciasValido = null
        this.montoPercepcionGananciasInvalidoMsj = this.displayErrorMonto(
          this.$v.montoPercepcionGanancias.$error,
          this.$v.montoPercepcionGanancias.decimal,
          this.$v.montoPercepcionGanancias.minValue
        )

        if (this.montoPercepcionGananciasInvalidoMsj.trim() != '') {
          this.montoPercepcionGananciasValido = false
        }
      }

      if (campo == 'montoPercepcionComercioIndustria' || validarTodos) {
        this.montoPercepcionComercioIndustriaValido = null
        this.montoPercepcionComercioIndustriaInvalidoMsj = this.displayErrorMonto(
          this.$v.montoPercepcionComercioIndustria.$error,
          this.$v.montoPercepcionComercioIndustria.decimal,
          this.$v.montoPercepcionComercioIndustria.minValue
        )

        if (this.montoPercepcionComercioIndustriaInvalidoMsj.trim() != '') {
          this.montoPercepcionComercioIndustriaValido = false
        }
      }

      if (campo == 'montoOtrosImpuestos' || validarTodos) {
        this.montoOtrosImpuestosValido = null
        this.montoOtrosImpuestosInvalidoMsj = this.displayErrorMonto(
          this.$v.montoOtrosImpuestos.$error,
          this.$v.montoOtrosImpuestos.decimal,
          this.$v.montoOtrosImpuestos.minValue
        )

        if (this.montoOtrosImpuestosInvalidoMsj.trim() != '') {
          this.montoOtrosImpuestosValido = false
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres'
          }
        } else {
          this.observacionesValidas = null
          this.observacionesInvalidasMsj = ''
        }
      }
    },
    displayErrorMonto(fieldError, fieldErrorDecimal, fieldErrorMinValue) {
      let errorMsj = ''
      if (fieldError) {
        if (fieldErrorDecimal) {
          errorMsj = 'El monto ingresado debe ser un valor numérico'
        } else if (fieldErrorMinValue) {
          errorMsj = 'El monto ingresado no es válido'
        }
      }
      return errorMsj
    },
    agregarRetencionCliente() {
      this.$refs.addRetencionClienteModal.show()
    },
    retencionClienteAgregada(retencionCliente) {
      this.$refs.addRetencionClienteModal.hide()
      this.$store
        .dispatch('ventaNegociacion/setRetencionCliente', retencionCliente)
        .catch((error) => this.showErrorMsj(error))
    },
    retencionClienteCancelada() {
      this.$refs.addRetencionClienteModal.hide()
    },
    borrarRetencionCliente(item) {
      this.$store.dispatch('ventaNegociacion/deleteRetencionCliente', item).catch((error) => this.showErrorMsj(error))
    },
    seleccionarProveedor() {
      this.$refs.searchProveedorModal.show()
    },
    proveedorSeleccionado(item) {
      this.$refs.searchProveedorModal.hide()
      this.showSpinner()
      this.$store
        .dispatch('ventaNegociacion/setProveedor', item)
        .then(() => {
          this.proveedorValido = null
          this.proveedorInvalidoMsj = ''
        })
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    bancoCuentaActualizada(bancoCuentaNombre) {
      if (!this.inicializando) {
        this.bancoCuentaNombre = bancoCuentaNombre

        let bancoCuenta = null
        if (this.bancoCuentaNombre) {
          bancoCuenta = this.getSelected(this.bancosCuentas, this.bancoCuentaNombre)
        }
        this.$store.dispatch('ventaNegociacion/setBancoCuenta', bancoCuenta)

        this.bancoCuentaValida = null
        this.bancoCuentaInvalidaMsj = ''
      }
    },
    setPercepcionesProvinciales() {
      this.$store.dispatch('comprapercepcionesprovinciales/inicializar', this.percepcionesProvinciales); 
      this.$refs.percepcionesModal.show();
    },
    updatePercepcionesProvinciales() {
      this.$store.dispatch('ventaNegociacion/setPercepciones', 
        this.$store.getters['comprapercepcionesprovinciales/percepciones']);
      this.$refs.percepcionesModal.hide()
    },
    closePercepcionesProvinciales() {
      this.$refs.percepcionesModal.hide()
    },    
    save() {
      let save = true

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false

      let proveedorError = true
      if (this.proveedor) {
        if (this.proveedor.id) {
          if (this.proveedor.id != 0) {
            proveedorError = false
          }
        }
      }
      if (proveedorError) {
        save = false
        this.proveedorValido = false
        this.proveedorInvalidoMsj = 'Debe seleccionar el agente correspondiente'
      }

      let bancoCuentaError = true
      if (this.bancoCuenta) {
        if (this.bancoCuenta.id) {
          if (this.bancoCuenta.id != 0) {
            bancoCuentaError = Boolean(false)
          }
        }
      }
      if (bancoCuentaError) {
        save = false
        this.bancoCuentaValida = false
        this.bancoCuentaInvalidaMsj = 'Debe seleccionar la cuenta correspondiente'
      }

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores()
      } else {
        if (save) {
          this.showSpinner()
          this.$store
            .dispatch('ventaNegociacion/save')
            .then(() =>
              this.showModalMsj(
                'La información de la negociación se registró con éxito.',
                this.goList,
                this.goList,
                'light'
              )
            )
            .catch((error) => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      }
    },
    goList() {
      this.$router.push({ name: 'Facturas' })
    },
  },
  validations: {
    numeroBoleto: { required, numeric, minValue: minValue(0) },
    montoAcreditado: { decimal, minValue: minValue(0) },
    montoIntereses: { decimal, minValue: minValue(0) },
    montoGastos: { decimal, minValue: minValue(0) },
    montoIvaInscripto: { decimal, minValue: minValue(0) },
    montoPercepcionIva: { decimal, minValue: minValue(0) },
    montoPercepcionGanancias: { decimal, minValue: minValue(0) },
    montoPercepcionComercioIndustria: { decimal, minValue: minValue(0) },
    montoOtrosImpuestos: { decimal, minValue: minValue(0) },
    observaciones: {
      maxLength: maxLength(5000),
    },
  },
}
</script>

<style></style>
